import { jsx as _jsx } from "react/jsx-runtime";
import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';
import { CopyrightCheckerPhotoOverviewView } from './CopyrightCheckerPhotoOverview.view';
function Overview({ data: resData, notice }) {
    const [data, setData] = useState(resData?.data || []);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPage] = useState(resData.current_page);
    useEffect(() => {
        router.on('start', () => {
            setLoading(true);
        });
        router.on('finish', () => {
            setLoading(false);
        });
    }, []);
    useEffect(() => {
        setData(resData?.data || []);
    }, [resData]);
    useEffect(() => {
        router.replace(location.pathname, {
            data: {
                page: pageNumber,
            },
            only: ['photos'],
        });
    }, [pageNumber]);
    return (_jsx(CopyrightCheckerPhotoOverviewView, { notice: notice, loading: loading, data: data, resData: resData, setPage: setPage }));
}
export default Overview;
